import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Tabs,
  Nav,
  Tab,
  Table,
  Modal,
  Image,
  Container,
  Card,
  Form
} from "react-bootstrap";
import { appConfig } from "../../config";

import ReactPaginate from "react-paginate";
import Switch from "react-switch";
var dateFormat = require("dateformat");

class AddCreditNotes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: {}
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange = event => {
    let name = event.target.name;
    let value = event.target.value;
    if (name == "crdtTo") {
      this.setState({
        value: { ...this.state.value, crdtTo: value }
      });
      // console.log("##########################", value);
    } else if (name == "crdtToGST") {
      this.setState({
        value: { ...this.state.value, crdtToGST: value }
      });
      // console.log("##########################", value);
    } else if (name == "addrInfoChmst") {
      this.setState({
        value: { ...this.state.value, addrInfoChmst: value }
      });
      // console.log("##########################", value);
    } else if (name == "crdtFromGST") {
      this.setState({
        value: { ...this.state.value, crdtFromGST: value }
      });
      // console.log("##########################", value);
    } else if (name == "addrInfoDistbtr") {
      this.setState({
        value: { ...this.state.value, addrInfoDistbtr: value }
      });
      // console.log("##########################", value);
    } else if (name == "descp") {
      this.setState({
        value: { ...this.state.value, descp: value }
      });
      // console.log("##########################", value);
    } else if (name == "qnty") {
      this.setState({
        value: { ...this.state.value, qnty: value }
      });
      // console.log("##########################", value);
    } else if (name == "amnt") {
      this.setState({
        value: { ...this.state.value, amnt: value }
      });
      // console.log("##########################", value);
    }
  };

  submit = () => {
    // let data = this.state.value;
    // console.log(data);
    const value = this.state.value;
    // console.log("##########################", value);
    if (
      value.crdtTo !== "" &&
      value.crdtToGST !== "" &&
      value.addrInfoChmst !== "" &&
      value.crdtFromGST !== "" &&
      value.addrInfoDistbtr !== "" &&
      value.descp !== "" &&
      value.qnty !== "" &&
      value.amnt !== ""
    ) {
      this.props.AddCreditNotes(this.state.value);
      this.setState({
        value: {}
      });
      this.props.closeAddCreditNotesModel();
      //   this.props.resetPage();
    } else {
    }
  };

  render() {
    return (
      <div>
        <div className="modelboxdesigns">
          <Modal
            show={this.props.showCreditNotesAddModel}
            onHide={this.props.closeAddCreditNotesModel}
            animation={false}
            size="lg"
            backdrop="static"
            className="Modalmodelboxdesigns"
            // style={{ backgroundColor: "rgba(0, 0, 0, 0.54)" }}
          >
            <Modal.Header
              style={{
                fontSize: "35px",
                backgroundColor: "#1768B7",
                color: "white"
              }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>Credit Notes</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Container>
                <div style={{ marginTop: "10px" }}>
                  <Row>
                    <Col xs={12} sm={6} md={4} lg={4}>
                      <Form>
                        <div>
                          <div>
                            <Form.Group controlId="crdtTo">
                              <Form.Label> Chemist Name</Form.Label>
                              <Form.Control
                                type="text"
                                autoComplete="off"
                                name="crdtTo"
                                onChange={this.onChange}
                                value={this.state.value.crdtTo}
                              />
                            </Form.Group>
                          </div>
                        </div>
                      </Form>
                    </Col>
                    <Col xs={12} sm={6} md={4} lg={4}>
                      <Form>
                        <div>
                          <div>
                            <Form.Group controlId="addrInfoChmst">
                              <Form.Label> Chemist Address </Form.Label>
                              <Form.Control
                                type="text"
                                autoComplete="off"
                                name="addrInfoChmst"
                                onChange={this.onChange}
                                value={this.state.value.addrInfoChmst}
                              />
                            </Form.Group>
                          </div>
                        </div>
                      </Form>
                    </Col>
                    <Col xs={12} sm={6} md={4} lg={4}>
                      <Form>
                        <div>
                          <div>
                            <Form.Group controlId="crdtToGST">
                              <Form.Label>Chemist GST</Form.Label>
                              <Form.Control
                                type="text"
                                autoComplete="off"
                                name="crdtToGST"
                                onChange={this.onChange}
                                value={this.state.value.crdtToGST}
                              />
                            </Form.Group>
                          </div>
                        </div>
                      </Form>
                    </Col>
                  </Row>
                </div>

                <div style={{ marginTop: "10px" }}>
                  <Row>
                    <Col xs={12} sm={6} md={4} lg={4}>
                      <Form>
                        <div>
                          <Form.Group controlId="addrInfoDistbtr">
                            <Form.Label>Distributor Address</Form.Label>

                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="addrInfoDistbtr"
                              onChange={this.onChange}
                              value={this.state.value.addrInfoDistbtr}
                            />
                          </Form.Group>
                        </div>
                      </Form>
                    </Col>
                    <Col xs={12} sm={6} md={4} lg={4}>
                      <Form>
                        <div>
                          <div>
                            <Form.Group controlId="crdtFromGST">
                              <Form.Label>Distributor GST</Form.Label>
                              <Form.Control
                                type="text"
                                autoComplete="off"
                                name="crdtFromGST"
                                onChange={this.onChange}
                                value={this.state.value.crdtFromGST}
                              />
                            </Form.Group>
                          </div>
                        </div>
                      </Form>
                    </Col>
                    <Col xs={12} sm={6} md={4} lg={4}>
                      <Form>
                        <div>
                          <div>
                            <Form.Group controlId="descp">
                              <Form.Label>Description</Form.Label>

                              <Form.Control
                                as="textarea"
                                rows="1"
                                name="descp"
                                autoComplete="off"
                                onChange={this.onChange}
                                value={this.state.value.descp}
                              />
                            </Form.Group>
                          </div>
                        </div>
                      </Form>
                    </Col>
                  </Row>
                </div>

                <div style={{ marginTop: "10px" }}>
                  <Row>
                    <Col xs={12} sm={6} md={4} lg={4}>
                      <Form>
                        <div>
                          <div>
                            <Form.Group controlId="qnty">
                              <Form.Label>Quantity </Form.Label>
                              <Form.Control
                                type="text"
                                autoComplete="off"
                                name="qnty"
                                onChange={this.onChange}
                                value={this.state.value.qnty}
                              />
                            </Form.Group>
                          </div>
                        </div>
                      </Form>
                    </Col>
                    <Col xs={12} sm={6} md={4} lg={4}>
                      <Form>
                        <div>
                          <div>
                            <Form.Group controlId="amnt">
                              <Form.Label> Amount </Form.Label>
                              <Form.Control
                                type="text"
                                autoComplete="off"
                                name="amnt"
                                onChange={this.onChange}
                                value={this.state.value.amnt}
                              />
                            </Form.Group>
                          </div>
                        </div>
                      </Form>
                    </Col>
                    <Col xs={12} sm={6} md={4} lg={4}></Col>
                  </Row>
                </div>
              </Container>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#1768B7" }}>
              <Button
                className="queryBtn"
                onClick={this.submit}
                style={{ backgroundColor: "#41C2D1", color: "white" }}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

export default AddCreditNotes;
